'use strict';

var NewExtractApplyFiltersSubpanelDirective = function NewExtractApplyFiltersSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-apply-filters-subpanel.html'),
    requires: '^rmDataExtractNewExtract'
  };
};
NewExtractApplyFiltersSubpanelDirective.$inject = [];
module.exports = NewExtractApplyFiltersSubpanelDirective;